module.exports = __webpack_public_path__ + "img/40_69_011_930.0ac2c20d.jpg";